import { render, staticRenderFns } from "./Sessions2.vue?vue&type=template&id=054106f8"
import script from "./Sessions2.vue?vue&type=script&lang=js"
export * from "./Sessions2.vue?vue&type=script&lang=js"
import style0 from "./Sessions2.vue?vue&type=style&index=0&id=054106f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports